import { useState } from 'react';
import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { useQuickstartUiStatus } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import { QUICKSTART_UI_STATUS } from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';

export const useIsD0APOrMLAP = createTraitsSelector<'SITE_USER'>(
	'SITE_USER',
	({ getTraitByName }) => {
		const isD0AP = getTraitByName('segment_day0_auto-provisioned_confluence_not_active_siteuser');
		const isMLAP = getTraitByName('segment_4c7a215c-2ec8-441a-b7c1-441e78eaaa72');
		return isD0AP?.value === true || isMLAP?.value === true;
	},
);

export const useIsD0AP = createTraitsSelector<'SITE_USER'>('SITE_USER', ({ getTraitByName }) => {
	const isD0AP = getTraitByName('segment_day0_auto-provisioned_confluence_not_active_siteuser');
	return isD0AP?.value === true;
});

export const useIsMLAP = createTraitsSelector<'SITE_USER'>('SITE_USER', ({ getTraitByName }) => {
	const isMLAP = getTraitByName('segment_4c7a215c-2ec8-441a-b7c1-441e78eaaa72');
	return isMLAP?.value === true;
});

/**
 * Determines if the user is eligible for the Pages Spotlight Nav4 experiment.
 * Eligibility criteria:
 * - User is in the D0AP or MLAP audience
 */
export function useIsPagesSpotlightNav4Eligible(): {
	isEligible: boolean;
	audience: string | null;
} {
	const [isD0AP] = useIsD0AP();
	const [isMLAP] = useIsMLAP();

	let audience = null;
	if (isD0AP) {
		audience = 'D0';
	} else if (isMLAP) {
		audience = 'ML';
	}

	return { isEligible: isD0AP || isMLAP, audience };
}

const statusDismissedSet = new Set([
	QUICKSTART_UI_STATUS.DISMISSED,
	QUICKSTART_UI_STATUS.MINIMIZED,
]);

/**
 * Determine if the quickstart has never been opened and is currently dismissed or minimized.
 */
export function useIsQuickstartDismissed(): boolean {
	const [quickstartStatus] = useQuickstartUiStatus();
	const [hasQuickstartBeenOpened, setHasQuickstartBeenOpened] = useState(false);
	const isOpen = quickstartStatus === QUICKSTART_UI_STATUS.OPEN;

	if (!hasQuickstartBeenOpened && isOpen) {
		setHasQuickstartBeenOpened(true);
	}

	return !hasQuickstartBeenOpened && statusDismissedSet.has(quickstartStatus);
}
